export const proxy_en = {
  'reset-password-modal': {
    title: 'Password Reset',
    description: 'Your account password has expired.\nPlease fill out the form below to reset your password.',
    form: {
      fields: {
        'current-password': {
          label: 'Current Password',
          placeholder: 'Enter your current password',
        },
        'new-password': {
          label: 'New Password',
          placeholder: 'Enter your new password',
        },
        'new-password-confirm': {
          name: 'New Password Confirm',
          label: 'New Password Confirm',
          placeholder: 'Enter your new password confirm',
        },
      },
      'submit-button': 'Submit',
    },
  },
  errors: {
    'invalid-current-password': 'The current password is incorrect.',
    'not-match-new-password': 'The new password does not match.',
    'already-used-password': 'The new password cannot be the same as the current password.',
    default: 'Invalid password reset request.\nPlease try to reset your password from the beginning.',
  },
};
